import React, { useEffect, useRef, useState } from 'react'
import Paper from '@mui/material/Paper'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import SearchIcon from '@mui/icons-material/Search'
import { Link } from 'react-router-dom'
import { styled } from '@mui/material/styles'

let autoComplete

const PREFIX = 'SearchStyles'
export const classes = {
  root: `${PREFIX}-root`
}

const SearchStyles = styled('input')(({ theme }) => ({
  [`&.${classes.root}`]: {
    color: theme.mode === 'dark' ? '#ffffff91' : '#00000091',
    padding: '4px 0px 5px',
    border: 0,
    boxSizing: 'content-box',
    background: 'none',
    height: '1.4375em',
    margin: 0,
    outline: 'none',
    display: 'block',
    width: '100%',
    animationName: 'mui-auto-fill-cancel',
    animationDuration: '10ms'
  }
}))

const paperSettings = { p: '2px 4px', display: 'flex', alignItems: 'center', width: 400, margin: 'auto' }

const loadScript = (url, callback) => {
  const script = document.createElement('script')
  script.type = 'text/javascript'

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        callback()
      }
    }
  } else {
    script.onload = () => callback()
  }

  script.src = url
  document.getElementsByTagName('head')[0].appendChild(script)
}

function handleScriptLoad (updateQuery, autoCompleteRef) {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { types: ['(cities)'], componentRestrictions: { country: 'us' } }
  )
  autoComplete.setFields(['address_components', 'formatted_address'])
  autoComplete.addListener('place_changed', () =>
    handlePlaceSelect(updateQuery)
  )
}

async function handlePlaceSelect (updateQuery) {
  const addressObject = autoComplete.getPlace()
  const query = addressObject.formatted_address
  updateQuery(query)
}

function SearchLocationInput () {
  const [query, setQuery] = useState('')
  const autoCompleteRef = useRef(null)
  useEffect(() => {
    loadScript(
            `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places`,
            () => handleScriptLoad(setQuery, autoCompleteRef)
    )
  }, [])

  return (

      <Paper component="form" sx={paperSettings}>
        <IconButton sx={{ p: '10px' }} aria-label="menu">
          <MenuIcon />
        </IconButton>
        <SearchStyles
          className={classes.root}
          ref={autoCompleteRef}
          onChange={event => setQuery(event.target.value)}
          placeholder="Enter a City"
          value={query}
        />
        <Divider sx={{ m: 0.5 }} style={{ height: 28 }} orientation="vertical" />
          <Link to={'/search'} style={{ textDecoration: 'none' }}>
            <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions">
              <SearchIcon />
            </IconButton>
          </Link>
      </Paper>
  )
}

export default SearchLocationInput
